<template>
  <b-modal id="change-status-modal" title="Change Status" centered>
    <div class="text-black">
      Are you sure you want to change the race status to
      <strong>{{ status }}</strong
      >?
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-end align-items-center">
        <b-button variant="secondary" class="mr-1" @click="closeModal"
          >Cancel</b-button
        >
        <b-button variant="primary" @click="onSubmit">Confirm </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { BModal, BButton } from "bootstrap-vue";
import { mapActions } from "vuex";
import { stringProp } from "@/helpers/props";
export default {
  components: {
    BModal,
    BButton,
  },
  props: {
    status: stringProp(),
  },
  methods: {
    ...mapActions("trading/racing", ["updateRaceDetail"]),
    async onSubmit() {
      const raceId = this.$route.query.raceId;
      if (!raceId) return;
      const result = await this.updateRaceDetail({
        raceId,
        finalStatus: this.status,
      });
      if (result) {
        this.$emit("onRefetch");
        this.closeModal();
      }
    },
    closeModal() {
      this.$bvModal.hide("change-status-modal");
    },
  },
};
</script>